import { backofficeRequest } from '../../../../axios'

export const addComment = async (ticketId, type, payload) => {
  try {
    const response = await backofficeRequest.post(
      `backoffice/${type.replace('_', '-')}/${ticketId}/comments`,
      payload
    )
    return response
  } catch (error) {
    return error.response
  }
}
export const getComments = async (ticketId, type) => {
  try {
    const response = await backofficeRequest.get(
      `backoffice/${type.replace('_', '-')}/${ticketId}/comments`
    )
    return response
  } catch (error) {
    return error.response
  }
}

export const deleteComment = async (ticketId, type, commentId) => {
  try {
    const response = await backofficeRequest.delete(
      `backoffice/${type.replace('_', '-')}/${ticketId}/comments/${commentId}`
    )
    return response
  } catch (error) {
    return error.response
  }
}

export const updateComment = async (ticketId, type, commentId, newComment) => {
  try {
    const response = await backofficeRequest.put(
      `backoffice/${type.replace('_', '-')}/${ticketId}/comments/${commentId}`,
      {
        comment: newComment,
      }
    )
    return response
  } catch (error) {
    return error.response
  }
}
